/*
                               (
                              (/(
                              (//(
                              (///(
                             (/////(
                             (//////(                          )
                            (////////(                        (/)
                            (////////(                       (///)
                           (//////////(                      (////)
                           (//////////(                     (//////)
                          (////////////(                    (///////)
                         (/////////////(                   (/////////)
                        (//////////////(                  (///////////)
                        (///////////////(                (/////////////)
                       (////////////////(               (//////////////)
                      (((((((((((((((((((              (((((((((((((((
                     (((((((((((((((((((              ((((((((((((((
                     (((((((((((((((((((            ((((((((((((((
                    ((((((((((((((((((((           (((((((((((((
                    ((((((((((((((((((((          ((((((((((((
                    (((((((((((((((((((         ((((((((((((
                    (((((((((((((((((((        ((((((((((
                    ((((((((((((((((((/      (((((((((
                    ((((((((((((((((((     ((((((((
                    (((((((((((((((((    (((((((
                   ((((((((((((((((((  (((((
                   #################  ##
                   ################  #
                  ################# ##
                 %################  ###
                 ###############(   ####
                ###############      ####
               ###############       ######
              %#############(        (#######
             %#############           #########
            ############(              ##########
           ###########                  #############
          #########                      ##############
        %######

        Powered by Knish.IO: Connecting a Decentralized World

Please visit https://github.com/WishKnish/KnishIO-Client-JS for information.

License: https://github.com/WishKnish/KnishIO-Client-JS/blob/master/LICENSE
 */
import AtomIndexException from './../exception/AtomIndexException.js'
import AtomsMissingException from './../exception/AtomsMissingException.js'
import MolecularHashMismatchException from './../exception/MolecularHashMismatchException.js'
import MolecularHashMissingException from './../exception/MolecularHashMissingException.js'
import PolicyInvalidException from './../exception/PolicyInvalidException.js'
import SignatureMalformedException from './../exception/SignatureMalformedException.js'
import SignatureMismatchException from './../exception/SignatureMismatchException.js'
import TransferBalanceException from './../exception/TransferBalanceException.js'
import TransferMalformedException from './../exception/TransferMalformedException.js'
import TransferMismatchedException from './../exception/TransferMismatchedException.js'
import TransferRemainderException from './../exception/TransferRemainderException.js'
import TransferToSelfException from './../exception/TransferToSelfException.js'
import TransferUnbalancedException from './../exception/TransferUnbalancedException.js'
import MetaMissingException from './../exception/MetaMissingException.js'
import WrongTokenTypeException from './../exception/WrongTokenTypeException.js'
import BatchIdException from './../exception/BatchIdException.js'
import Atom from './../Atom.js'
import Meta from './../Meta.js'
import Molecule from './../Molecule.js'
import Wallet from './../Wallet.js'
import Rule from '../instance/Rules/Rule.js'
import {
  base64ToHex,
  chunkSubstr
} from './strings.js'
import JsSHA from 'jssha'
import Dot from './../libraries/Dot.js'

/**
 *
 */
export default class CheckMolecule {
  /**
   *
   * @param molecule
   */
  constructor (molecule) {
    // No molecular hash?
    if (molecule.molecularHash === null) {
      throw new MolecularHashMissingException()
    }

    // No atoms?
    if (!molecule.atoms.length) {
      throw new AtomsMissingException()
    }

    // Check atom indexes
    for (const atom of molecule.atoms) {
      if (atom.index === null) {
        throw new AtomIndexException()
      }
    }

    this.molecule = molecule
  }

  /**
   *
   * @param senderWallet
   * @returns {false|*|boolean}
   */
  verify (senderWallet) {
    return this.molecularHash() &&
      this.ots() &&
      this.batchId() &&
      this.continuId() &&
      this.isotopeM() &&
      this.isotopeT() &&
      this.isotopeC() &&
      this.isotopeU() &&
      this.isotopeI() &&
      this.isotopeR() &&
      this.isotopeP() &&
      this.isotopeA() &&
      this.isotopeB() &&
      this.isotopeF() &&
      this.isotopeV(senderWallet)
  }

  /**
   *
   * @returns {boolean}
   */
  continuId () {
    const firstAtom = this.molecule.atoms[0]

    if (firstAtom.token === 'USER' && this.molecule.getIsotopes('I').length < 1) {
      throw new AtomsMissingException('Check::continuId() - Molecule is missing required ContinuID Atom!')
    }

    return true
  }

  /**
   *
   * @returns {boolean}
   */
  batchId () {
    if (this.molecule.atoms.length > 0) {
      const signingAtom = this.molecule.atoms[0]

      if (signingAtom.isotope === 'V' && signingAtom.batchId !== null) {
        const atoms = this.molecule.getIsotopes('V')
        const remainderAtom = atoms[atoms.length - 1]

        if (signingAtom.batchId !== remainderAtom.batchId) {
          throw new BatchIdException()
        }

        for (const atom of atoms) {
          if (atom.batchId === null) {
            throw new BatchIdException()
          }
        }
      }

      return true
    }

    throw new BatchIdException()
  }

  /**
   *
   * @returns {boolean}
   */
  isotopeI () {
    for (const atom of this.molecule.getIsotopes('I')) {
      if (atom.token !== 'USER') {
        throw new WrongTokenTypeException(`Check::isotopeI() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      if (atom.index === 0) {
        throw new AtomIndexException(`Check::isotopeI() - Isotope "${ atom.isotope }" Atoms must have a non-zero index!`)
      }
    }

    return true
  }

  /**
   *
   * @returns {boolean}
   */
  isotopeU () {
    for (const atom of this.molecule.getIsotopes('U')) {
      if (atom.token !== 'AUTH') {
        throw new WrongTokenTypeException(`Check::isotopeU() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      if (atom.index !== 0) {
        throw new AtomIndexException(`Check::isotopeU() - Isotope "${ atom.isotope }" Atoms must have an index equal to 0!`)
      }
    }

    return true
  }

  /**
   *
   * @returns {boolean}
   */
  isotopeM () {
    const policyArray = ['readPolicy', 'writePolicy']

    for (/** @type {Atom} */ const atom of this.molecule.getIsotopes('M')) {
      if (atom.meta.length < 1) {
        throw new MetaMissingException()
      }

      if (atom.token !== 'USER') {
        throw new WrongTokenTypeException(`Check::isotopeM() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      const metas = Meta.aggregateMeta(atom.meta)

      for (const key of policyArray) {
        let policy = metas[key]

        if (policy) {
          policy = JSON.parse(policy)

          for (const [policyName, policyValue] of Object.entries(policy)) {
            if (!policyArray.includes(policyName)) {
              if (!Object.keys(metas).includes(policyName)) {
                throw new PolicyInvalidException(`${ policyName } is missing from the meta.`)
              }

              for (const value of policyValue) {
                if (!Wallet.isBundleHash(value) && !['all', 'self'].includes(value)) {
                  throw new PolicyInvalidException(`${ value } does not correspond to the format of the policy.`)
                }
              }
            }
          }
        }
      }
    }

    return true
  }

  /**
   *
   * @returns {boolean}
   */
  isotopeC () {
    for (const atom of this.molecule.getIsotopes('C')) {
      if (atom.token !== 'USER') {
        throw new WrongTokenTypeException(`Check::isotopeC() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      if (atom.index !== 0) {
        throw new AtomIndexException(`Check::isotopeC() - Isotope "${ atom.isotope }" Atoms must have an index equal to 0!`)
      }
    }

    return true
  }

  /**
   *
   * @returns {boolean}
   */
  isotopeT () {
    for (const atom of this.molecule.getIsotopes('T')) {
      const meta = atom.aggregatedMeta()
      const metaType = String(atom.metaType).toLowerCase()

      if (metaType === 'wallet') {
        for (const key of ['position', 'bundle']) {
          if (!Object.prototype.hasOwnProperty.call(meta, key) || !meta[key]) {
            throw new MetaMissingException(`Check::isotopeT() - Required meta field "${ key }" is missing!`)
          }
        }
      }

      for (const key of ['token']) {
        if (!Object.prototype.hasOwnProperty.call(meta, key) || !meta[key]) {
          throw new MetaMissingException(`Check::isotopeT() - Required meta field "${ key }" is missing!`)
        }
      }

      if (atom.token !== 'USER') {
        throw new WrongTokenTypeException(`Check::isotopeT() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      if (atom.index !== 0) {
        throw new AtomIndexException(`Check::isotopeT() - Isotope "${ atom.isotope }" Atoms must have an index equal to 0!`)
      }
    }

    return true
  }

  /**
   *
   * @returns {boolean}
   */
  isotopeR () {
    for (const atom of this.molecule.getIsotopes('R')) {
      const metas = atom.aggregatedMeta()

      if (metas.policy) {
        const policy = JSON.parse(metas.policy)

        if (!Object.keys(policy).every(i => ['read', 'write'].includes(i))) {
          throw new MetaMissingException('Check::isotopeR() - Mixing rules with politics!')
        }
      }

      if (metas.rule) {
        const rules = JSON.parse(metas.rule)

        if (!Array.isArray(rules)) {
          throw new MetaMissingException('Check::isotopeR() - Incorrect rule format!')
        }

        for (const item of rules) {
          Rule.toObject(item)
        }

        if (rules.length < 1) {
          throw new MetaMissingException('Check::isotopeR() - No rules!')
        }
      }
    }

    return true
  }

  /**
   * Validates P-isotope (Peering) atoms
   *
   * @returns {boolean}
   */
  isotopeP () {
    for (const atom of this.molecule.getIsotopes('P')) {
      if (atom.token !== 'USER') {
        throw new WrongTokenTypeException(`Check::isotopeP() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      const metas = atom.aggregatedMeta()

      if (!Object.prototype.hasOwnProperty.call(metas, 'peerHost') || !metas.peerHost) {
        throw new MetaMissingException('Check::isotopeP() - Required meta field "peerHost" is missing!')
      }
    }

    return true
  }

  /**
   * Validates A-isotope (Append Request) atoms
   *
   * @returns {boolean}
   */
  isotopeA () {
    for (const atom of this.molecule.getIsotopes('A')) {
      if (atom.token !== 'USER') {
        throw new WrongTokenTypeException(`Check::isotopeA() - "${ atom.token }" is not a valid Token slug for "${ atom.isotope }" isotope Atoms!`)
      }

      if (!atom.metaType) {
        throw new MetaMissingException('Check::isotopeA() - Required field "metaType" is missing!')
      }

      if (!atom.metaId) {
        throw new MetaMissingException('Check::isotopeA() - Required field "metaId" is missing!')
      }

      const metas = atom.aggregatedMeta()

      if (!Object.prototype.hasOwnProperty.call(metas, 'action') || !metas.action) {
        throw new MetaMissingException('Check::isotopeA() - Required meta field "action" is missing!')
      }
    }

    return true
  }

  /**
   * Validates B-isotope (Buffer/Exchange) atoms
   *
   * @returns {boolean}
   */
  isotopeB () {
    const isotopeB = this.molecule.getIsotopes('B')

    if (isotopeB.length === 0) {
      return true
    }

    for (const atom of isotopeB) {
      // B atoms must reference a wallet bundle
      if (!atom.metaType || atom.metaType !== 'walletBundle') {
        throw new MetaMissingException('Check::isotopeB() - B-isotope atoms must have metaType "walletBundle"!')
      }

      if (!atom.metaId) {
        throw new MetaMissingException('Check::isotopeB() - B-isotope atoms must have a metaId!')
      }

      // Value must be parseable as a number
      const value = Number(atom.value)
      if (Number.isNaN(value)) {
        throw new TransferMalformedException('Check::isotopeB() - B-isotope atom value is not a valid number!')
      }
    }

    // V+B balance conservation: sum of all V and B atom values must equal zero
    const vAtoms = this.molecule.getIsotopes('V')
    if (vAtoms.length > 0) {
      let sum = 0
      for (const atom of [...vAtoms, ...isotopeB]) {
        const value = Number(atom.value)
        if (!Number.isNaN(value)) {
          sum += value
        }
      }
      if (sum !== 0) {
        throw new TransferUnbalancedException('Check::isotopeB() - V+B atom values do not balance to zero!')
      }
    }

    return true
  }

  /**
   * Validates F-isotope (Fusion/NFT) atoms
   *
   * @returns {boolean}
   */
  isotopeF () {
    const isotopeF = this.molecule.getIsotopes('F')

    if (isotopeF.length === 0) {
      return true
    }

    for (const atom of isotopeF) {
      // F atoms must reference a wallet bundle
      if (!atom.metaType || atom.metaType !== 'walletBundle') {
        throw new MetaMissingException('Check::isotopeF() - F-isotope atoms must have metaType "walletBundle"!')
      }

      if (!atom.metaId) {
        throw new MetaMissingException('Check::isotopeF() - F-isotope atoms must have a metaId!')
      }

      // Value must be parseable
      const value = Number(atom.value)
      if (Number.isNaN(value)) {
        throw new TransferMalformedException('Check::isotopeF() - F-isotope atom value is not a valid number!')
      }

      if (value < 0) {
        throw new TransferMalformedException('Check::isotopeF() - F-isotope atom value must not be negative!')
      }
    }

    // V+F balance conservation: sum of all V and F atom values must equal zero
    const vAtoms = this.molecule.getIsotopes('V')
    if (vAtoms.length > 0) {
      let sum = 0
      for (const atom of [...vAtoms, ...isotopeF]) {
        const value = Number(atom.value)
        if (!Number.isNaN(value)) {
          sum += value
        }
      }
      if (sum !== 0) {
        throw new TransferUnbalancedException('Check::isotopeF() - V+F atom values do not balance to zero!')
      }
    }

    return true
  }

  /**
   *
   * @param senderWallet
   * @returns {boolean}
   */
  isotopeV (senderWallet = null) {
    const isotopeV = this.molecule.getIsotopes('V')

    if (isotopeV.length === 0) {
      return true
    }

    // When B or F atoms are present, cross-isotope conservation is validated
    // by isotopeB()/isotopeF() — skip V-only conservation check
    const hasCrossIsotope = this.molecule.getIsotopes('B').length > 0 ||
      this.molecule.getIsotopes('F').length > 0

    const firstAtom = this.molecule.atoms[0]

    if (!hasCrossIsotope && firstAtom.isotope === 'V' && isotopeV.length === 2) {
      const endAtom = isotopeV[isotopeV.length - 1]

      if (firstAtom.token !== endAtom.token) {
        throw new TransferMismatchedException()
      }

      if (endAtom.value < 0) {
        throw new TransferMalformedException()
      }

      // Conservation check for 2-atom transfers
      if ((Number(firstAtom.value) + Number(endAtom.value)) !== 0) {
        throw new TransferUnbalancedException()
      }

      return true
    }

    let sum = 0
    let value = 0

    for (const index in this.molecule.atoms) {
      if (Object.prototype.hasOwnProperty.call(this.molecule.atoms, index)) {
        const vAtom = this.molecule.atoms[index]

        // Not V? Next...
        if (vAtom.isotope !== 'V') {
          continue
        }

        // Making sure we're in integer land
        value = vAtom.value * 1

        if (Number.isNaN(value)) {
          throw new TypeError('Invalid isotope "V" values')
        }

        // Making sure all V atoms of the same token
        if (vAtom.token !== firstAtom.token) {
          throw new TransferMismatchedException()
        }

        // Checking non-primary atoms
        if (index > 0) {
          // Negative V atom in a non-primary position?
          if (value < 0) {
            throw new TransferMalformedException()
          }

          // Cannot be sending and receiving from the same address
          if (vAtom.walletAddress === firstAtom.walletAddress) {
            throw new TransferToSelfException()
          }
        }

        // Adding this Atom's value to the total sum
        sum += value
      }
    }

    // V-only conservation: all V atoms must sum to zero (skip for B/F cross-isotope)
    if (!hasCrossIsotope && sum !== 0) {
      throw new TransferUnbalancedException()
    }

    // If we're provided with a senderWallet argument, we can perform additional checks
    if (senderWallet) {
      value = firstAtom.value * 1

      if (Number.isNaN(value)) {
        throw new TypeError('Invalid isotope "V" values')
      }

      const remainder = Number(senderWallet.balance) + value

      // Is there enough balance to send?
      if (remainder < 0) {
        throw new TransferBalanceException()
      }

      // Does the remainder match what should be there in the source wallet, if provided?
      // Skip for cross-isotope (B/F) — conservation is validated by isotopeB()/isotopeF()
      if (!hasCrossIsotope && remainder !== sum) {
        throw new TransferRemainderException()
      }
    } else if (value !== 0) {
      // No senderWallet, but have a remainder?
      throw new TransferRemainderException()
    }

    // Looks like we passed all the tests!
    return true
  }

  /**
   * Verifies if the hash of all the atoms matches the molecular hash to ensure content has not been messed with
   *
   * @returns {boolean}
   */
  molecularHash () {
    if (this.molecule.molecularHash !== Atom.hashAtoms({
      atoms: this.molecule.atoms
    })) {
      throw new MolecularHashMismatchException()
    }

    // Looks like we passed all the tests!
    return true
  }

  /**
   * Checks if the provided molecule was signed properly by transforming a collection of signature
   * fragments from its atoms and its molecular hash into a single-use wallet address to be matched
   * against the sender’s address. If it matches, the molecule was correctly signed.
   *
   * @returns {boolean}
   */
  ots () {
    // Convert Hm to numeric notation via EnumerateMolecule(Hm)
    const normalizedHash = this.molecule.normalizedHash()

    // Rebuilding OTS out of all the atoms
    let ots = this.molecule.atoms.map(
      atom => atom.otsFragment
    ).reduce(
      (accumulator, otsFragment) => accumulator + otsFragment
    )

    // Wrong size? Maybe it's compressed
    if (ots.length !== 2048) {
      // Attempting decompression
      ots = base64ToHex(ots)

      // Still wrong? That's a failure
      if (ots.length !== 2048) {
        throw new SignatureMalformedException()
      }
    }

    // Subdivide Kk into 16 segments of 256 bytes (128 characters) each
    const otsChunks = chunkSubstr(ots, 128)

    let keyFragments = ''

    for (const index in otsChunks) {
      let workingChunk = otsChunks[index]

      for (let iterationCount = 0, condition = 8 + normalizedHash[index]; iterationCount < condition; iterationCount++) {
        workingChunk = (new JsSHA('SHAKE256', 'TEXT')).update(workingChunk).getHash('HEX', { outputLen: 512 })
      }

      keyFragments += workingChunk
    }

    // Absorb the hashed Kk into the sponge to receive the digest Dk
    const digestSponge = new JsSHA('SHAKE256', 'TEXT')
    digestSponge.update(keyFragments)
    const digest = digestSponge.getHash('HEX', { outputLen: 8192 })

    // Squeeze the sponge to retrieve a 128 byte (64 character) string that should match the sender’s wallet address
    const addressSponge = new JsSHA('SHAKE256', 'TEXT')
    addressSponge.update(digest)
    const address = addressSponge.getHash('HEX', { outputLen: 256 })

    // Signing atom
    const signingAtom = this.molecule.atoms[0]

    // Get a signing address
    let signingAddress = signingAtom.walletAddress

    // Get signing wallet from first atom's metas
    const signingWallet = Dot.get(signingAtom.aggregatedMeta(), 'signingWallet')

    // Try to get custom signing address from the metas (local molecule with server secret)
    if (signingWallet) {
      signingAddress = Dot.get(JSON.parse(signingWallet), 'address')
    }

    if (address !== signingAddress) {
      throw new SignatureMismatchException()
    }

    // Looks like we passed all the tests!
    return true
  }

  /**
   * Converts server-side molecule data (from GraphQL meta query responses)
   * into a Molecule instance suitable for verification via CheckMolecule.
   *
   * Handles field mapping differences between server and client:
   * - tokenSlug → token
   * - metasJson (JSON string) → meta (array of {key, value})
   * - bundleHash → bundle
   *
   * @param {object} serverData - Molecule data from GraphQL response
   * @param {string} serverData.molecularHash
   * @param {string} serverData.bundleHash
   * @param {string|null} serverData.cellSlug
   * @param {string|null} serverData.status
   * @param {string|null} serverData.createdAt
   * @param {array} serverData.atoms - Array of server-format atom objects
   * @return {Molecule}
   */
  static fromServerData ({
    molecularHash,
    bundleHash,
    cellSlug = null,
    status = null,
    createdAt = null,
    atoms = []
  }) {
    const mappedAtoms = atoms.map(serverAtom => {
      let meta = []
      if (serverAtom.metasJson) {
        try {
          const parsed = JSON.parse(serverAtom.metasJson)
          if (Array.isArray(parsed)) {
            // Already in [{key, value}] format
            meta = parsed
          } else if (parsed && typeof parsed === 'object') {
            // Object format {key1: val1, key2: val2} — convert to [{key, value}] pairs
            meta = Object.entries(parsed).map(([key, value]) => ({ key, value }))
          }
        } catch (e) {
          meta = []
        }
      }

      return {
        position: serverAtom.position || null,
        walletAddress: serverAtom.walletAddress || null,
        isotope: serverAtom.isotope || null,
        token: serverAtom.tokenSlug || serverAtom.token || null,
        value: serverAtom.value != null ? String(serverAtom.value) : null,
        batchId: serverAtom.batchId || null,
        metaType: serverAtom.metaType || null,
        metaId: serverAtom.metaId || null,
        meta,
        index: serverAtom.index != null ? serverAtom.index : null,
        otsFragment: serverAtom.otsFragment || null,
        createdAt: serverAtom.createdAt || null
      }
    })

    return Molecule.fromJSON({
      molecularHash,
      bundle: bundleHash,
      cellSlug,
      status,
      createdAt,
      atoms: mappedAtoms
    })
  }

  /**
   * Verifies a molecule reconstructed from server-side GraphQL data.
   * Returns an object with verification result and any error details.
   *
   * @param {object} moleculeData - Server molecule data (same format as fromServerData)
   * @return {{ molecularHash: string, verified: boolean, error: string|null }}
   */
  static verifyFromServerData (moleculeData) {
    try {
      const molecule = CheckMolecule.fromServerData(moleculeData)
      new CheckMolecule(molecule).verify()
      return {
        molecularHash: moleculeData.molecularHash,
        verified: true,
        error: null
      }
    } catch (error) {
      return {
        molecularHash: moleculeData.molecularHash || null,
        verified: false,
        error: error.message || String(error)
      }
    }
  }
}
